import React from "react";
import { Row, Col, Button } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { ListGroupsForUsers } from "./groupsUserTable/ListGroupsForUsers";
import { ACL } from '../../../../../config/constants';


function UserGroupsTab(props) {
  const {
    user,
    groupsUserIsIn,
    groupsUserIsNotIn,
    updateGroups,
    submit,
  } = props;

  const addUserInGroup = (group, index) => {
    if (! ACL.ADMIN.GROUPS.SYNC_USERS.hasAccess()) {
      return;
    }

    let cloneGroupsUserIsIn = [ ...groupsUserIsIn ];
    let cloneGroupsUserIsNotIn = [ ...groupsUserIsNotIn ];

    cloneGroupsUserIsNotIn.splice( index, 1 );
    cloneGroupsUserIsIn.push( group );
    group.users.push( user );

    updateGroups( cloneGroupsUserIsIn, cloneGroupsUserIsNotIn );
  };

  const removeUserFromGroup = (group, index) => {
    if (! ACL.ADMIN.GROUPS.SYNC_USERS.hasAccess()) {
      return;
    }

    let cloneGroupsUserIsIn = [ ...groupsUserIsIn ];
    let cloneGroupsUserIsNotIn = [ ...groupsUserIsNotIn ];

    cloneGroupsUserIsIn.splice( index, 1 );
    cloneGroupsUserIsNotIn.push( group );
    group.users = group.users.filter( item => item.id !== user.id );

    updateGroups( cloneGroupsUserIsIn, cloneGroupsUserIsNotIn );
  };

  return (
    <div className="admin-user-detail-section admin-user-detail-section--groups">
          <Row className="admin-user-detail-groups">
            <Col md="6" className="admin-user-detail-groups__column pr-md-2" data-testid="groups-user-is-not-in">
              <Row className="justify-content-center mt-2 text-center">
                <h4><FormattedMessage
                  id="components.admin.tabs.admin_groups_tab.groups_user_is_not_in"/>
                </h4>
              </Row>
              <ListGroupsForUsers
                groups={groupsUserIsNotIn}
                addUserInGroup={addUserInGroup}
              />
            </Col>
            <Col md="6" className="admin-user-detail-groups__column pl-md-2" data-testid="groups-user-is-in">
              <Row className="justify-content-center mt-2 text-center">
                <h4><FormattedMessage
                  id="components.admin.tabs.admin_groups_tab.groups_user_is_in"/>
                </h4>
              </Row>
              <ListGroupsForUsers
                groups={groupsUserIsIn}
                removeUserFromGroup={removeUserFromGroup}
                displayUsersGroup={true}
              />
            </Col>
          </Row>
          {ACL.ADMIN.GROUPS.SYNC_USERS.hasAccess() && <Row className="admin-user-detail-section__actions">
            <Col className="text-right py-3">
              <Button id="button.create"
                      color="primary"
                      onClick={(e) => {
                        e.preventDefault();
                        submit();
                      }}
              >
                <FormattedMessage id="button.save"/>
              </Button>
            </Col>
          </Row>}
    </div>
  );
}

export { UserGroupsTab }
